export default __webpack_public_path__ + "f06974318ee9c9eab3bc61077321fb1c.png";